<style scoped>
</style>

<template>

<div class="jumbotron bg-transparent text-center margin-none">
    <div class="modal fade slide-down in" style="display: block;">
        <div class="modal-dialog">
            <div class="v-cell">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title modal-inverse">{{ title }}</h3>
                    </div>
                    <div class="modal-body">
                        <div class="panel panel-default">
                            <div class="panel-body">
                                <form @submit.prevent="submit">
                                    <div class="form-group form-control-default">
                                        <label for="authName">管理员账号</label>
                                        <input class="form-control" id="authName" placeholder="管理员账号" type="text" v-model="current.Name">
                                    </div>
                                    <div class="form-group form-control-default">
                                        <label for="authPassword">密码</label>
                                        <input type="password" class="form-control" id="authPassword" placeholder="密码" v-model="current.Password">
                                    </div>
                                    <div v-if="!initialized" class="form-group form-control-default">
                                        <label for="authConfirm">确认密码</label>
                                        <input type="password" class="form-control" id="authConfirm" placeholder="确认密码" v-model="current.ConfirmPassword">
                                    </div>
                                    <p class="text-muted">{{ subtitle }}</p>
                                    <button type="submit" class="btn btn-success">{{ buttonText }}</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>

export default {
    name: 'login',
    props: {
        initialized: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            current: {
                Name: '',
                Password: '',
                ConfirmPassword: ''
            }
        }
    },
    computed: {
        title: function() {
            if (this.initialized) {
                return '管理员登录'
            }
            return '初始化管理员账号'
        },
        subtitle: function() {
            if (this.initialized) {
                return '登录后才能访问管理机配置和运行状态。'
            }
            return '首次启动请先创建管理员账号，后续访问必须登录。'
        },
        buttonText: function() {
            if (this.initialized) {
                return '登录'
            }
            return '初始化并登录'
        }
    },
    methods: {
        submit: function() {
            if (this.current.Name === '' || this.current.Password === '') {
                alert('用户名和密码不能为空')
                return
            }
            if (!this.initialized && this.current.Password !== this.current.ConfirmPassword) {
                alert('两次输入的密码不一致')
                return
            }
            var url = this.initialized ? '/auth/login' : '/auth/setup'
            var body = {
                name: this.current.Name,
                password: this.current.Password
            }
            this.$http.post(url, body).then(function(res) {
                if (res.data.error) {
                    alert(res.data.message || '操作失败')
                    return
                }
                this.current = this.temp()
                this.$emit('authenticated')
            }, function(err) {
                var message = '登录服务器异常'
                if (!this.initialized) {
                    message = '初始化管理员失败'
                }
                if (err && err.body && err.body.message) {
                    alert(err.body.message)
                    return
                }
                alert(message)
            })
        },
        temp: function() {
            return {
                Name: '',
                Password: '',
                ConfirmPassword: ''
            }
        }
    }
}

</script>



// WEBPACK FOOTER //
// Login.vue?308b020c